import React, { useEffect } from 'react';

/**
 * Hook that alerts clicks outside of the passed ref
 */
export function useOutsideAlerter(
  ref: React.RefObject<HTMLDivElement | HTMLButtonElement>,
  parentRef: React.RefObject<HTMLDivElement | HTMLButtonElement>,
  callback: any,
) {
  useEffect(() => {
    /**
     * Alert if clicked on outside of element
     */
    function handleClickOutside(event: any) {
      if (
        ref.current &&
        parentRef.current &&
        !ref.current.contains(event.target) &&
        !parentRef.current.contains(event.target)
      ) {
        callback();
      }
    }
    // Bind the event listener
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [ref, parentRef, callback]);
}
